// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { IReturnMailDetails } from './IReturnMailDetails';
import {
    instanceOfIReturnMailDetails,
    IReturnMailDetailsFromJSON,
    IReturnMailDetailsFromJSONTyped,
    IReturnMailDetailsToJSON,
} from './IReturnMailDetails';
import type { IReturnedCheckDetails } from './IReturnedCheckDetails';
import {
    instanceOfIReturnedCheckDetails,
    IReturnedCheckDetailsFromJSON,
    IReturnedCheckDetailsFromJSONTyped,
    IReturnedCheckDetailsToJSON,
} from './IReturnedCheckDetails';

/**
 * @type ILockboxDtoDetails
 * 
 * @export
 */
export type ILockboxDtoDetails = IReturnMailDetails | IReturnedCheckDetails;

export function ILockboxDtoDetailsFromJSON(json: any): ILockboxDtoDetails {
    return ILockboxDtoDetailsFromJSONTyped(json, false);
}

export function ILockboxDtoDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ILockboxDtoDetails {
    if (json == null) {
        return json;
    }
    if (typeof json !== 'object') {
        return json;
    }
    if (instanceOfIReturnMailDetails(json)) {
        return IReturnMailDetailsFromJSONTyped(json, true);
    }
    if (instanceOfIReturnedCheckDetails(json)) {
        return IReturnedCheckDetailsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function ILockboxDtoDetailsToJSON(json: any): any {
    return ILockboxDtoDetailsToJSONTyped(json, false);
}

export function ILockboxDtoDetailsToJSONTyped(value?: ILockboxDtoDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    if (typeof value !== 'object') {
        return value;
    }
    if (instanceOfIReturnMailDetails(value)) {
        return IReturnMailDetailsToJSON(value as IReturnMailDetails);
    }
    if (instanceOfIReturnedCheckDetails(value)) {
        return IReturnedCheckDetailsToJSON(value as IReturnedCheckDetails);
    }

    return {};
}

